import globalDomains from '@/utils/global-domains';
import ApiCore from '@/api/index';

const StaticFileApi = ApiCore(globalDomains.STATIC_FILE_AFREECATV, false);
export default StaticFileApi;
